//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  computed: {
    event() {
      return this.$store.state.event.data;
    },
    direction() {
      const id = this.event?.directionId;
      if (!id) return;
      return this.$store.getters['eventsList/GET_DIRECTION_BY_ID'](id);
    },
    nodes() {
      if (!this.direction) return [];
      const path = this.$store.state.eventsList.path;

      return [
        {
          path: '/',
          label: this.$t('eventos.breadcrumbs.home'),
        },
        {
          path,
          label: this.$t('eventos.breadcrumbs.eventos'),
        },
        {
          path: `${path}/${this.direction.eventSlug}`,
          label: this.direction.shortName,
        },
      ];
    },
  },
};
